import { connect } from 'react-redux';
import Search from './Search';


let mapStateToProps = (state) => {
  return {
    productsPage: state.productsPage
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const SearchContainer = connect(mapStateToProps, mapDispatchToProps)(Search);

export default SearchContainer;